<template>
  <v-dialog v-model="dialog" width="1200">
    <v-card :loading="loading">
      <v-card-title class="grey--text text-subtitle-1">
        <v-icon color="grey" class="mr-2">mdi-format-list-bulleted</v-icon>
        Storico Print Jobs
        <v-spacer />
        <v-select
          v-model="periodo"
          :items="periodo_items"
          dense
          outlined
          hide-details
          style="max-width:160px"
          class="mr-3"
          @change="refresh"
        />
        <v-btn icon :loading="loading" @click="refresh">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-btn icon color="red" @click="show_purge = !show_purge">
          <v-icon>mdi-delete-sweep</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Pannello purge -->
      <v-expand-transition>
        <v-sheet v-if="show_purge" color="red lighten-5" class="px-4 py-3">
          <v-row align="center" no-gutters>
            <v-col cols="auto" class="mr-3">
              <span class="text-caption red--text font-weight-medium">Elimina job precedenti al</span>
            </v-col>
            <v-col cols="2" class="mr-3">
              <v-select
                v-model="purge_before"
                :items="purge_before_items"
                dense
                outlined
                hide-details
              />
            </v-col>
            <v-col cols="3" class="mr-3">
              <v-select
                v-model="purge_state"
                :items="purge_state_items"
                dense
                outlined
                hide-details
                label="Stato"
              />
            </v-col>
            <v-col cols="auto">
              <v-btn
                small
                color="red"
                dark
                :loading="purging"
                @click="esegui_purge"
              >
                <v-icon small left>mdi-delete-forever</v-icon>
                Elimina
              </v-btn>
            </v-col>
            <v-col cols="auto" class="ml-2">
              <v-expand-x-transition>
                <v-icon color="success" v-if="purge_ok">mdi-check</v-icon>
              </v-expand-x-transition>
            </v-col>
          </v-row>
        </v-sheet>
      </v-expand-transition>

      <v-card-text class="pt-3">
        <v-row no-gutters class="mb-2 text-caption font-weight-medium grey--text">
          <v-col cols="3">Prodotto</v-col>
          <v-col cols="2">Serie</v-col>
          <v-col cols="3">Colore</v-col>
          <v-col cols="2">Lotto</v-col>
          <v-col cols="1">Stato</v-col>
          <v-col cols="1">Creato</v-col>
        </v-row>
        <v-divider class="mb-3" />
        <v-row
          v-for="job in print_jobs"
          :key="job.id"
          no-gutters
          align="center"
          class="mb-2"
        >
          <v-col cols="3" class="grey--text text-body-2">{{ labelOf(job).prodotto }}</v-col>
          <v-col cols="2" class="grey--text text-body-2">{{ labelOf(job).serie }}</v-col>
          <v-col cols="3" class="grey--text text-body-2">{{ labelOf(job).colore }}</v-col>
          <v-col cols="2" class="grey--text text-body-2">{{ labelOf(job).lotto }}</v-col>
          <v-col cols="1">
            <v-chip x-small :color="jobStateColor(job.state)" dark>{{ job.state }}</v-chip>
          </v-col>
          <v-col cols="1" class="grey--text text-caption">{{ formatTs(job.created_at) }}</v-col>
        </v-row>
        <v-row v-if="!loading && print_jobs.length === 0" no-gutters>
          <v-col cols="12" class="text-center grey--text py-4">Nessun job trovato</v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text color="grey" @click="dialog = false">Chiudi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
export default {
  name: "PrintJobsDialog",
  data() {
    return {
      dialog: false,
      loading: false,
      periodo: 0,
      periodo_items: [
        { text: "Oggi", value: 0 },
        { text: "7 giorni", value: 7 },
        { text: "30 giorni", value: 30 },
        { text: "Tutto", value: null },
      ],
      show_purge: false,
      purging: false,
      purge_ok: false,
      purge_before: 7,
      purge_before_items: [
        { text: "Adesso", value: 0 },
        { text: "Ieri", value: 1 },
        { text: "7 giorni fa", value: 7 },
        { text: "30 giorni fa", value: 30 },
        { text: "90 giorni fa", value: 90 },
      ],
      purge_state: "done,dead_letter",
      purge_state_items: [
        { text: "Completati e falliti", value: "done,dead_letter" },
        { text: "Solo completati", value: "done" },
        { text: "Solo falliti", value: "dead_letter" },
        { text: "Tutti gli stati", value: null },
      ],
    };
  },
  computed: {
    print_jobs() {
      return this.$store.getters.get_print_jobs;
    },
  },
  methods: {
    open() {
      this.dialog = true;
      this.refresh();
    },
    refresh() {
      this.loading = true;
      const from = this.periodo != null
        ? moment().subtract(this.periodo, "days").startOf("day").unix()
        : undefined;
      this.$store.dispatch("fetch_print_jobs", { from }).finally(() => {
        this.loading = false;
      });
    },
    esegui_purge() {
      this.purging = true;
      const before = this.purge_before === 0
        ? moment().toISOString()
        : moment().subtract(this.purge_before, "days").startOf("day").toISOString();
      const state = this.purge_state || undefined;
      this.$store
        .dispatch("purge_print_jobs", { before, state })
        .then(() => {
          this.purge_ok = true;
          this.refresh();
          setTimeout(() => {
            this.purge_ok = false;
            this.show_purge = false;
          }, 1500);
        })
        .finally(() => {
          this.purging = false;
        });
    },
    labelOf(job) {
      return (job.payload && job.payload.label) || {};
    },
    jobStateColor(state) {
      const map = {
        pending: "orange",
        processing: "blue",
        done: "green",
        dead_letter: "red",
      };
      return map[state] || "grey";
    },
    formatTs(ts) {
      if (!ts) return "—";
      return moment.unix(ts).format("DD/MM/YY HH:mm");
    },
  },
};
</script>
